<template>
  <div ref="main">
    <div class="collection-hero__wrapper" v-if="campaignImageUrl === null">
      <div class="collection-hero collection-hero__with-border t-d">
        <div class="collection-hero__text collection-hero__header" :class="textAlignmentClass">
          <img
            v-if="mobileImageUrl &&  $mq !== 'mobile'"
            :src="mobileImageUrl"
            :alt="currentHeadingText"
            
          >
          <h1 v-else-if="!aboutTheBrandSettings.text"
            :class="[currentHeadingColor, $mq !== 'mobile' ? 'h2' : 'h3']"
          >{{currentHeadingText}}</h1>
        </div>
        <div class="collection-hero__text collection-hero__content" :class="textAlignmentClass">
        <div>
           <h1 v-if="mobileImageUrl"
            :class="[currentHeadingColor, $mq !== 'mobile' ? 'h2' : 'h3']"
          >{{currentHeadingText}}</h1>
        </div>
          <p
            class="body-sm-mobile body-md-tablet-up"
            v-if="heroSettings.copy"
            :class="currentHeadingTextColor"
          >{{heroSettings.copy}}</p>
          <!-- <a
            href="#shopify-section-collection-grid"
            class="collection-hero__arrow"
            v-if="aboutTheBrandSettings.text"
            @click.prevent="scrollToGrid()"
          >
            <icon name="arrow_long_thin_down"></icon>
          </a> -->
        </div>
      </div>
    </div>
    <div class="collection-hero__wrapper-campaign" v-if="campaignImageUrl !== null">
      <img
          v-if="campaignImageUrl"
          :src="campaignImageUrl"
          :alt="campaignCollectionImages.imageAlt"
        >
    </div>

    <div
      class="container"
      v-if="false && aboutTheBrandSettings.text && campaignImageUrl === null"
    >
      <div class="collection-hero collection-hero__brand-wrapper t-d">
        <div class="collection-hero__text" :class="textAlignmentClass">
          <div class="collection-hero__brand">
            <h2
              :class="[currentHeadingColor, $mq !== 'mobile' ? 'h3' : 'h4']"
            >About {{currentHeadingText}}</h2>
            <p
              class="body-sm-mobile body-md-tablet-up"
              v-if="aboutTheBrandSettings.text"
              :class="currentHeadingTextColor"
            >{{aboutTheBrandSettings.text}}</p>
            <a
              href="#more-about-the-brand"
              class="button-wrapper button button--primary"
              v-if="aboutTheBrandSettings.hasMoreBrandText"
              @click.prevent="scrollToBrandInfo()"
            >
              <span class="button__content">Read More</span>
            </a>
          </div>
        </div>
        <div class="collection-hero__text collection-hero__content" :class="textAlignmentClass">
          <img
            v-if="aboutTheBrandSettings.imageUrl"
            :src="aboutTheBrandSettings.imageUrl"
            alt=""
          >
        </div>
      </div>
    </div>
    <div class="collection-hero__quiz-container">

        <a :href="heroSettings.quizURL" target="_blank" v-if="quizImageUrl!==''">
          <img
              :src="quizImageUrl"
              :alt="heroSettings.quizAlt"
            >
        </a>
    </div>
  </div>
</template>

<script>
import { scrollToElement } from '@/scripts/helpers/util.js';
import Icon from '@/scripts/components/basic/Icon.vue'
import CollectionBreadcrumbsB from '@/scripts/components/collection/CollectionBreadcrumbsB';

export default {
  name: 'CollectionHero',
  components: {
    CollectionBreadcrumbsB,
    Icon
  },
  props: {
    defaultSettings: {
      type: Object,
      required: true,
      default: () => ({
        heading: String,
        backgroundColor: String,
        headingColor: String,
        textColor: String,
      }),
    },
    breadcrumbs: {
      type: Object,
      required: true,
      default: () => ({
        collectionTitle: String,
        collectionHandle: String,
      }),
    },
    customHeaderHtml: String,
    heroSettings: {
      type: Object,
      required: true,
      default: () => ({
        heading: String,
        copy: String,
        imageUrl: String,
        backgroundColor: String,
        headingColor: String,
        textColor: String,
      }),
    },
    alternateSettings: {
      type: Object,
      required: false,
      default: () => ({
        layout: String,
        layoutAlignment: String,
        textAlignment: String,
        mobileImage: String,
      }),
    },
    aboutTheBrandSettings: {
      type: Object,
      default: () => ({
        text: String,
        imageUrl: String,
        hasMoreBrandText: Boolean
      })
    },
    campaignCollectionImages: {
      type: Object,
      default: () =>  ({
        desktopImageUrl: null,
        mobileImageUrl: null,
      })
    }
  },
  mounted() {
    // this.$refs.main.innerHTML = this.customHeaderHtml;
    const containerDiv = document.createElement('div');
    containerDiv.innerHTML = this.customHeaderHtml;

    const sliderScript = containerDiv.querySelector('script');
    const elements = containerDiv.querySelectorAll('*');

    if (sliderScript && elements && elements.length) {
      const script = document.createElement('script');
      script.innerHTML = sliderScript.innerHTML;

      this.$refs.main.innerHTML = this.customHeaderHtml;

      this.$refs.main.appendChild(script);
    }
  },
  computed: {
    layoutClass() {
      const layout = this.alternateSettings.layout;

      if (layout) {
        if (layout === 'Textbox Overlaid') {
          return 'overlaid';
        }
        if (layout === 'Textbox Adjacent') {
          return 'adjacent';
        }
      }
      return undefined;
    },
    layoutAlignmentClass() {
      const alignment = this.alternateSettings.layoutAlignment;

      if (alignment) {
        if (alignment === 'Left') {
          return 'align-left';
        }
        if (alignment === 'Right') {
          return 'align-right';
        }
      }
      return undefined;
    },
    textAlignmentClass() {
      const alignment = this.alternateSettings.textAlignment;

      if (alignment) {
        if (alignment === 'Left') {
          return 'text-left';
        }
        if (alignment === 'Center') {
          return 'text-center';
        }
      }
      return this.heroSettings.imageUrl.length ? 'text-left' : 'text-center';
    },
    currentBgColor() {
      return this.heroSettings.backgroundColor
        ? this.getClass(this.heroSettings.backgroundColor)
        : this.defaultSettings.backgroundColor;
    },
    currentHeadingColor() {
      return this.heroSettings.headingColor
        ? this.getClass(this.heroSettings.headingColor)
        : this.defaultSettings.headingColor;
    },
    currentHeadingText() {
      return this.heroSettings.heading
        ? this.heroSettings.heading
        : this.defaultSettings.heading;
    },
    currentHeadingTextColor() {
      return this.heroSettings.textColor
        ? this.getClass(this.heroSettings.textColor)
        : this.defaultSettings.textColor;
    },
    mobileImageUrl() {
      return this.$mq === 'mobile' && this.alternateSettings.mobileImage
        ? this.alternateSettings.mobileImage
        : this.heroSettings.imageUrl;
    },
    campaignImageUrl() {
      return this.$mq === 'mobile'? this.campaignCollectionImages.mobileImageUrl:this.campaignCollectionImages.desktopImageUrl
    },
    aboutBrandImage(){
      return this.$mq === 'mobile'? this.aboutTheBrandSettings.imageUrl:this.aboutTheBrandSettings.imageUrl
    },
    quizImageUrl() {
      return this.$mq === 'mobile'? this.heroSettings.quizMobileImage:this.heroSettings.quizDesktopImage
    }
  },
  methods: {
    scrollToBrandInfo () {
      const toScrollTo = document.querySelector('#more-about-the-brand');
      scrollToElement(toScrollTo);
    },
    scrollToGrid () {
      const toScrollTo = document.querySelector('#shopify-section-collection-grid');
      scrollToElement(toScrollTo);
    },
    getClass(metafield) {
      return metafield.split(' - ')[1];
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0;
  background-color: transparent;
  @include mobile-only {
    padding: 0;
  }
}

.collection-hero__wrapper {
  padding: 0 32px;
  @include mobile-only {
    padding: 0 15px;
  }
}
.collection-hero__wrapper-campaign {
  padding: 0px;
  text-align: center;
}

.collection-hero {
  width: 100%;
  //min-height: 400px;
  display: flex;
  align-items:center;
  padding: 45px 0 45px;

  &__with-border {
    border-top: 1px solid #979391;
    border-bottom: 1px solid #979391;
    @include mobile-only {
      border-color: transparent;
    }
  }

  @include mobile-only {
    padding: 30px 0 30px;
    min-height: 0;
    //max-width: 344px;
    margin: 0 auto;
    display: block;
  }

  &__arrow {
    border: 1px solid #000000;
    height: 60px;
    width: 60px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    @include mobile-only {
      margin-left: auto;
      margin-right: auto;
    }
  }

  &__with-image,
  &__no-image {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include mobile-only {
      flex-direction: column;
    }
    &-image {
      width: 54.19%;
      height: 352px;
      background-size: cover;
      background-position: center;
      @include mobile-only {
        width: 100%;
        height: 176px;
      }
    }
  }

  &__text {
    padding: 0 32px;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    @include mobile-only {
      padding: 0px 15px;
      width: 100%;
      text-align: center;
      min-height: 0;
    }
    img {
      align-self: center;
      max-width: 240px;
    }
    h1 {
      margin: auto;
      font-size: 52px;
      letter-spacing: 0;
      line-height: 1;
      font-family: "Ginkgo-Light";
      font-weight: 400;
      text-transform: none;
      padding-bottom: 10px;


      @include mobile-only {
        font-size: 28px;
      }
    }
    p {
      font-size: 15px;
      letter-spacing: -0.1px;
      line-height: 23px;

      //margin: 16px 0 0;
      @include mobile-only {
        //margin: 8px 0 0;
        margin: 0 auto;
      }
    }
  }

  &__header {
    @include mobile-only {
      padding-bottom: 12px;
      img {
        padding-bottom: 24px;
      }
    }
  }

  &__content {

  }

  &__brand-wrapper {
    padding-top: 75px;
    padding-bottom: 75px;
    align-items: center;
    img {
      max-width: 100%;
    }
    @include mobile-only {
      padding-top: 40px;
    }

    .collection-hero__text {
      padding: 0;
    }
  }

  &__brand {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
    @include mobile-only {
      padding-bottom: 42px;
      padding-left: 18px;
      padding-right: 18px;
      max-width: 356px;
    }

    h2 {
      font-size: 32px;
      letter-spacing: 0;
      line-height: 42px;
      text-transform: none;
      margin-bottom: 16px;
    }

    .button {
      margin-top: 24px;
    }
  }

  &__with-image {
    .collection-hero__text {
      @include tablet-up {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    &.align-left {
      flex-direction: row;
      @include mobile-only {
        flex-direction: column-reverse;
      }
    }
    &.align-right {
      flex-direction: row-reverse;
      @include mobile-only {
        flex-direction: column-reverse;
      }
    }
    &.overlaid {
      .collection-hero__text {
        box-shadow: 1px 2px 4px -1px rgba(0, 0, 0, 0.2);
        border-radius: 4px;

        @include mobile-only {
          padding: 24px 13px;
          width: 90%;
          text-align: center;
          margin-top: -64px;
          margin-bottom: 32px;
          z-index: 5;
          box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.2);
        }
      }
      .collection-hero__with-image-image {
        width: 80%;
        @include mobile-only {
          width: 100%;
        }
      }
      .collection-hero__text {
        @include tablet-up {
          padding: 32px;
          margin: 16px 0;
          z-index: 5;
        }
      }
      &.align-left {
        .collection-hero__text {
          @include tablet-up {
            margin-right: -128px;
          }
        }
      }
      &.align-right {
        .collection-hero__text {
          @include tablet-up {
            margin-left: -128px;
          }
        }
      }
    }
  }
  &__no-image {
    .text-left {
      margin: 0;
      text-align: left;
    }
  }
  &__quiz-container {
    padding: 0;
    margin: 30px 0 0 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @include mobile-only {
      padding: 0;
      margin: 0 0 10px 0;
      width: 100%;
      display: block;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }

 /deep/ &__brand-image{
    max-width: 100%;
  }

}
.text-center {
  margin: 0 auto;
}
</style>
